import React, { useEffect, useState } from 'react'
import { stakeHoldersData } from './StakeHoldersData'
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Card, Grid } from '@material-ui/core';

import StakeUpdateForm from './StakeUpdateForm';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1
    },
    gridContainerOuter: {
        margin: '6px -6px',
        display: 'flex',
        justifyContent: 'center'
    },
    gridItemInner: {
        padding: '0px 6px'
    },
    titleDiv: {
        padding: '8px 0px 12px 0px'
    },
    listTitle: {
        padding: 15
    },
    listItem: {
        padding: 16
    },
    editDiv: {
        padding: 12
    }
});

function StakeHolderEdit({ match }) {
    const classes = useStyles();
    const [stake, setStake] = useState({})
    useEffect(() => {
        console.log(match)
        let id = match.params.id
        let obj = stakeHoldersData.filter(item => item.id === id)
        setStake(obj)

    }, [match])

    const submithandlerProp = (val) => {
        console.log("received")
        console.log(val)
        console.log(stake[0])
        console.log(stake[0].id)
        let stake_updated = stakeHoldersData.map(x => x.id === stake[0].id ? { ...stake[0], ...val } : x);
        console.log(stake_updated)
    }

    return (

        <div className={classes.root}>


            <div className={classes.titleDiv}>
                <Typography variant="h2">Stake Holder - Edit</Typography>
            </div>
            <Grid container className={classes.gridContainerOuter}>
                <Grid item xs={12} className={classes.gridItemInner}>

                    <Card >

                        <div className={classes.editDiv}>

                            {
                                (stake && stake.length) ?
                                    (
                                        <StakeUpdateForm holder={stake[0]} submithandlerProp={(val) => submithandlerProp(val)} />
                                    ) : (
                                        <div className={classes.listTitle}>
                                            <Typography variant="h5">Stake Holder information not found</Typography>
                                        </div>
                                    )
                            }

                        </div>

                    </Card>
                </Grid>
            </Grid>
        </div>
    )
}

export default StakeHolderEdit

